import React, { Component } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import {
  actionAddArray2Redux,
  selectARecord,
  initSelectedRecord,
  setUiFlag,
  loadAllStats,
  resetRedux,
  loadFbData,
  notifyUsers,
  getId,
  getAcctStatement,
  getAcctBalance
} from "../../../../store/actions";

import ContentGridVanilla from "../ContentGrid/ContentGridVanilla";
import {
  MainRegion,
  Content,
  Container,
  Button,
  CardActions,
  CardActionsSupplemental
} from "reactackle";
import getDefs from "../../../../staticData/getDefs";
import { searchRecords } from "../../searches/searchRecords";
import { getMenuList, getInitData } from "./getMenuList";
import "./landingPage.css";
import { throttle, debounce } from "throttle-debounce";
import GridFilters from "../ContentGrid/GridFilters";
import GridDateFilters from "../ContentGrid/GridDateFilters";
import { isMobile } from "react-device-detect";
import getExtendedOgDefs from "../../TableDefinitions/extendedOgDef";
import TextInputField from "../FieldsComponents/TextInputField/TextInputField";
import ScrollPositionManager from "./ScrollPositionManager";

class Grocer extends Component {
  constructor(props) {
    super(props);
    ////console.log("...test... " + JSON.stringify(tableDefs));
    this.state = {
      data: {
        path: "",
        payload: {
          paymentType: "",
          supplierInvoice: "",
          referenceNumber: "",
          paymentDate: ""
        }
      },
      message: "",
      hasLoaded: false,
      tableName: "deliveryRequest",
      tableDefs: getDefs(this.props.createTable),
      searchVal: "",
      showGrid: true,
      showDash: false,
      searchFilters: {},
      searchDateFilters: {},
      showFilters: true,
      showPivot: false,
      reRenderFlag: false,
      formDefs: getExtendedOgDefs(this.props.createTable),
      notInitialized: true,
      loginProgress: false,
      logview: [],
      showPackingConfirmation: false,
      stage: "showGrid"
    };
    this.getDataDebounced = debounce(1000, this.doStateUpdateForSearch);
    this.getDataThrottled = throttle(1000, this.doStateUpdateForSearch);
  }

  componentDidMount() {
    if (
      this.state.notInitialized &&
      !this.props.firebase.auth &&
      this.props.firebase.auth === undefined
    ) {
      /*
      searchDateFilters: {
            FromDate: moment()
              .format("DD-MM-YYYY")
              .toString(),
            tgtDateField: "deliveryDate",
            tgtDateFormat: "DD-MM-YYYY",
            ToDate: moment()
              .format("DD-MM-YYYY")
              .toString()
          }
      */
      let supplierName = window.location.pathname.replace("/", "");
      if (supplierName && supplierName !== "") {
        supplierName = supplierName.toUpperCase();
      }
      this.setState(prevState => {
        return {
          ...prevState,
          logview: [...prevState.logview, "BROOKLYNZ"],
          notInitialized: false,
          supplierName: supplierName
        };
      });
      this.props.firebase.doInitiate("BROOKLYNZ");
    }

    window.addEventListener("scroll", this.handleScroll);

    this.setState(prevState => {
      return {
        ...prevState,
        showFilters: !isMobile
      };
    });

    this.props.firebase.auth
      .signInWithEmailAndPassword("grocer@grocer.com.sg", "p123456")
      .then(userRes => {
        //console.log("stringify and parse done/skipped");
        let res = userRes;

        this.props
          .loadFbData("createTable", this.props.firebase)
          .then(crTableRes => {
            //console.log("crTableRes: " + JSON.stringify(crTableRes));

            this.props
              .loadFbData("listOfTables", this.props.firebase)
              .then(listRes => {
                this.props
                  .loadFbData("menuDesigner", this.props.firebase)
                  .then(desRes => {
                    this.stateChangeHandler("login done", "logview", false);
                    this.props.onSetUiFlag("showSpinner", false);
                    //console.log("ui flag switched off");

                    this.props.onSetUiFlag("userUid", res.uid);
                    //console.log("set ui flag user id");
                    this.props.onSetUiFlag("userEmail", res.email);
                    //console.log("email updated");

                    //console.log("inside load data: " + this.refs.email.value);
                    let currEmail = "grocer@grocer.com.sg";
                    this.props.firebase.db
                      .ref("/users")
                      .on("value", snapshot => {
                        ////console.log("Linking " + tableName);
                        let tmpArray = [];
                        let fbOject = [];
                        Promise.all([snapshot.val()]).then(res => {
                          fbOject = res[0];
                          //console.log("now recieved the response for teams loading");
                          tmpArray = Object.keys(fbOject).map(key => ({
                            ...fbOject[key],
                            key: key
                          }));
                          tmpArray.reverse();
                          //console.log("array reversed");
                          ////console.log("Total Records: " + tmpArray.length);
                          this.props.onAddArray({
                            path: "users",
                            payload: tmpArray
                          });

                          let currentUser = {};

                          //

                          currentUser = tmpArray.find(userObj => {
                            if (userObj.userEmail === currEmail) {
                              return userObj;
                            }
                          });

                          // console.log(
                          //   "admin status: " + JSON.stringify(currentUser)
                          // );

                          this.props.onAddRecord({
                            path: "userProfile",
                            payload: currentUser
                          });

                          if (currentUser !== undefined) {
                            ////console.log("~!@~!@ " + JSON.stringify(currentUser));
                            let isThisAdmin =
                              currentUser.roleName === "ADMIN" ||
                              currentUser.roleName === "SUPERADMIN";
                            let isThisSuperAdmin =
                              currentUser.roleName === "SUPERADMIN";
                            this.props.onSetUiFlag(
                              "currUserRole",
                              currentUser.roleName
                            );
                            this.props.onSetUiFlag("isThisAdmin", isThisAdmin);
                            this.props.onSetUiFlag(
                              "isThisSuperAdmin",
                              isThisSuperAdmin
                            );

                            let allMenus = {};
                            let allMenusFromDb = this.props.menuDesigner;
                            if (allMenusFromDb && allMenusFromDb.length > 0) {
                              let userMenu = allMenusFromDb.find(
                                singMenu =>
                                  singMenu.name === currentUser.roleName
                              );
                              if (userMenu) {
                                allMenus = userMenu.menuItems.map(
                                  singleMenu => {
                                    let srcTable = this.props.listOfTables.find(
                                      item => item.name === singleMenu.tableName
                                    );
                                    if (
                                      srcTable &&
                                      srcTable !== undefined &&
                                      srcTable.name
                                    ) {
                                      return {
                                        ...singleMenu,
                                        menuCaption: srcTable.menu
                                      };
                                    }
                                  }
                                );
                                this.props.onSetUiFlag("userMenus", allMenus);
                              }
                            }

                            this.props.onAddRecord({
                              path: "currentUser",
                              payload: currentUser
                            });

                            this.props.onAddRecord({
                              path: "team",
                              payload: {
                                name: "BROOKLYNZ",
                                fbCloudUrl: "",
                                fbDbUrl: ""
                              }
                            });

                            let allTableDets = this.props.userMenus;
                            if (allTableDets && allTableDets.length > 0) {
                              for (let k = 0; k < allTableDets.length; k++) {
                                this.loadDataEx(allTableDets[k]);
                              }
                            } else {
                              console.log("tables not linked");
                            }
                          }
                        });
                      });
                  });
              });
          });
      })
      .catch(error => {
        this.setState(prevState => {
          return {
            ...prevState,
            message: error.message,
            loginProgress: false,
            logview: [...prevState.logview, error]
          };
        });
      });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {
    if (this.state.stage === "showGrid") {
      this.props.onSetUiFlag("listYPos", window.scrollY);
    }
  };

  applyDataCondition = (singleRecord, dataCondition) => {
    //console.log("~~||~~ " + JSON.stringify(singleRecord));
    //console.log("~~ in the loop" + JSON.stringify(dataCondition));
    let tmpRes = false;

    for (let p = 0; p < dataCondition.length; p++) {
      // console.log(
      //   "~~~ signRec: " +
      //     singleRecord[dataCondition[p]["colKey"]] +
      //     " cond: " +
      //     dataCondition[p]["colKey"] +
      //     "=" +
      //     dataCondition[p]["fieldVal"] +
      //     " OR " +
      //     this.props.userProfile[dataCondition[p]["fieldVal"]]
      // );
      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        dataCondition[p]["fieldVal"]
      ) {
        tmpRes = true;
      }

      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        this.props.userProfile[dataCondition[p]["fieldVal"]]
      ) {
        tmpRes = true;
      }
    }
    //console.log("~~ returning: " + tmpRes);
    return tmpRes;
  };

  displayToGrocer = (item, tableName) => {
    if (tableName === "deliveryRequest" && item && item !== undefined) {
      let specificSupplierCheck =
        (item.supplier && item.supplier.includes(this.state.supplierName)) ||
        (item.supplier && item.supplier.includes("ALL"));
      if (
        item.supplierPrices &&
        item.supplierPrices.length > 0 &&
        item.status.includes("FOR PRICE")
      ) {
        let priceQuoteObj = item.supplierPrices.find(
          pObj => pObj.supplierName === this.state.supplierName
        );

        if (priceQuoteObj && priceQuoteObj !== undefined) {
          specificSupplierCheck = false;
        }
      }

      let itemStatusCheck = item.status && item.status.includes("WITH GROCER");
      if (itemStatusCheck && specificSupplierCheck) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  loadDataEx = allTableDets => {
    //console.log(JSON.stringify(allTableDets));
    let recsLimit = 0;

    if (isMobile) {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recMobileLimit);
      }
    } else {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recLimit);
      }
    }

    let basePath = "/";
    let tableName = allTableDets.tableName;
    if (recsLimit > 0) {
      this.props.firebase.db
        .ref(basePath + tableName)
        .limitToLast(recsLimit)
        .on("value", snapshot => {
          let tmpArray = [];
          let fbOject = [];
          Promise.all([snapshot.val()]).then(res => {
            fbOject = res[0];
            if (fbOject && fbOject !== null && fbOject !== undefined) {
              Object.keys(fbOject).map(key => {
                let item = {
                  ...fbOject[key],
                  key: key
                };
                console.log("~~ Linking " + JSON.stringify(allTableDets));
                if (
                  allTableDets.dataConditions &&
                  allTableDets.dataConditions !== undefined &&
                  allTableDets.dataConditions.length > 0
                ) {
                  //console.log(JSON.stringify(allTableDets.dataConditions));
                  if (
                    this.applyDataCondition(item, allTableDets.dataConditions)
                  ) {
                    if (this.displayToGrocer(item, tableName)) {
                      tmpArray.push(item);
                    }
                  }
                } else {
                  if (this.displayToGrocer(item, tableName)) {
                    tmpArray.push(item);
                  }
                }
              });
            }
            //reverse to have latest at the top
            //tmpArray.reverse();
            this.props.onAddRecord({
              path: tableName,
              payload: tmpArray
            });
          });
        });
    } else {
      this.props.firebase.db.ref(basePath + tableName).on("value", snapshot => {
        let tmpArray = [];
        let fbOject = [];
        Promise.all([snapshot.val()]).then(res => {
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            Object.keys(fbOject).map(key => {
              let item = {
                ...fbOject[key],
                key: key
              };
              //console.log("~~ Linking " + JSON.stringify(allTableDets));
              if (
                allTableDets.dataConditions &&
                allTableDets.dataConditions !== undefined &&
                allTableDets.dataConditions.length > 0
              ) {
                //console.log(JSON.stringify(allTableDets.dataConditions));
                if (
                  this.applyDataCondition(item, allTableDets.dataConditions)
                ) {
                  if (this.displayToGrocer(item, tableName)) {
                    tmpArray.push(item);
                  }
                }
              } else {
                if (this.displayToGrocer(item, tableName)) {
                  tmpArray.push(item);
                }
              }
            });
          }
          //reverse to have latest at the top

          this.props.onAddRecord({
            path: tableName,
            payload: tmpArray
          });
          this.setState(prevState => {
            return {
              ...prevState,
              formDefs: getExtendedOgDefs(this.props.createTable),
              tableDefs: getDefs(this.props.createTable)
            };
          });
        });
      });
    }
    //}
  };

  loadData = (tableName, isDeleted) => {
    //console.log(tableName);
    let recsLimit = 3000;
    if (isMobile) {
      recsLimit = 2000;
    }
    if (tableName === "attendance") {
      if (isMobile) {
        recsLimit === 2000;
      } else {
        recsLimit === 3000;
      }
    }
    let basePath = "/";
    if (isDeleted) {
      basePath = "/deletedRecs/";
    }
    this.props.firebase.db
      .ref(basePath + tableName)
      .limitToLast(recsLimit)
      .on("value", snapshot => {
        ////console.log("Linking " + tableName);
        let tmpArray = [];
        let fbOject = [];
        let projTempArray = [];
        Promise.all([snapshot.val()]).then(res => {
          //basic updating keys into objects
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            tmpArray = Object.keys(fbOject).map(key => ({
              ...fbOject[key],
              key: key
            }));
          }
          //reverse to have latest at the top
          //tmpArray.reverse();

          //filter project table for engineer and contributor
          if (
            tableName === "projects" &&
            (this.props.currUserRole === "ENGINEER" ||
              this.props.currUserRole === "CONTRIBUTOR")
          ) {
            projTempArray = tmpArray.filter(item => {
              return item.projectPhase === "IN FLIGHT";
            });

            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: projTempArray
              });
            } else {
              this.props.onAddRecord({
                path: tableName,
                payload: projTempArray
              });
            }
          } else {
            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: tmpArray
              });
            } else {
              this.props.onAddRecord({ path: tableName, payload: tmpArray });
            }
          }
        });
      });
  };

  getTopMenu = () => {
    return (
      <nav className="navbar navbar-default navbar-fixed-top">
        <div
          className="container-fluid"
          style={{
            paddingTop: "0px"
          }}
        >
          <div className="navbar-header">
            <a
              className="navbar-brand"
              href="#"
              style={{
                marginLeft: "10px",
                marginRight: "-20px",
                color: "black"
              }}
            >
              BCS
            </a>
          </div>
        </div>
      </nav>
    );
  };

  fetchMenus = () => {
    //console.log("Fetching...");
    //console.log("Props userMenu: " + JSON.stringify(this.props.userMenus));
    return getMenuList(
      true,
      this.isAdmin(),
      this.switchMenu,
      this.props.currUserRole,
      this.props.userMenus
    );
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  logoutApp = () => {
    let msgToApp = {
      actionType: "logOut",
      payload: {}
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing logout message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  switchMenu = menuName => {
    let unhandledMenu = [
      "checkLists",
      "clientFeedback",
      "soa",
      "chequesPayments",
      "creditNotes"
    ];
    if (unhandledMenu.includes(menuName)) {
      alert("Wheels are spinning.... \nThis feature is coming soon!!!");
      return;
    }
    if (this.refs && this.refs.searchText) {
      this.refs.searchText.value = "";
      this.doDelaySearch();
    }
    this.stateChangeHandler({}, "searchFilters", false);
    this.stateChangeHandler({}, "searchDateFilters", false);
    this.stateChangeHandler(false, "showPivot", false);
    if (menuName === "dashboard") {
      this.stateChangeHandler(true, "showDash", false);
      this.stateChangeHandler(false, "showGrid", false);
      this.stateChangeHandler(menuName, "tableName", false);
    } else if (menuName === "signout") {
      this.props.firebase.doSignOut();
      this.props.onSignOut();
      this.logoutApp();
      browserHistory.push("/login");
    } else {
      this.stateChangeHandler(true, "showGrid", false);
      this.stateChangeHandler(false, "showDash", false);
      this.stateChangeHandler(menuName, "tableName", false);
    }
  };

  isAdmin = () => {
    return this.props.isAdmin || this.props.isSuperAdmin;
  };

  handleDelete = (key, path, searchObj) => {
    this.props.firebase.db.ref("/" + path + "/" + key).remove();
    this.genNotification(searchObj, "delete");
    this.stateChangeHandler(true, "showGrid", false);
  };

  getFormattedCellValue = jsonValue => {
    if (jsonValue && jsonValue !== "" && typeof jsonValue === "string") {
      let valArray = jsonValue.split("\n");
      if (valArray.length > 1) {
        return valArray.map((item, index) => {
          return (
            <div style={{ paddingLeft: "10px" }}>{index + 1 + ". " + item}</div>
          );
        });
      } else {
        return jsonValue;
      }
    } else {
      return jsonValue;
    }
  };

  getPriceConfirmation = () => {
    return (
      <div>
        <div
          style={{
            fontSize: "medium",
            fontWeight: "bold",
            margin: "5px"
          }}
        >
          What is total price of this order:
        </div>
        <div
          style={{
            border: "1px solid grey",
            borderRadius: "5px",
            padding: "5px"
          }}
        >
          <div
            style={{
              marginTop: "3px",
              marginBottom: "3px"
            }}
          >
            <TextInputField
              title={"PRICE"}
              value={this.state.data.payload.grocerPrice}
              stateChangeHandler={this.stateChangeHandler}
              fieldName={"grocerPrice"}
              disabled={false}
              type={null}
              message={""}
              placeholder={"100"}
            />
          </div>
          <div
            style={{
              marginTop: "3px",
              marginBottom: "3px"
            }}
          >
            <TextInputField
              title={"ANY COMMENTS"}
              value={this.state.data.payload.grocerComments}
              stateChangeHandler={this.stateChangeHandler}
              fieldName={"grocerComments"}
              disabled={false}
              type={null}
              message={""}
              multiline
              placeholder={"Onion and Jeeri not available"}
            />
          </div>
          <div
            style={{
              marginTop: "3px",
              marginBottom: "3px"
            }}
          >
            <CardActions>
              <CardActionsSupplemental>
                <Button
                  text="SUBMIT PRICE"
                  onPress={() => {
                    window.confirm(
                      "Proceed with total of price of : " +
                        this.state.data.payload.grocerPrice +
                        "?"
                    ) && this.directSave(false, false);
                  }}
                  colorScheme="primary"
                  disabled={
                    this.state.data.payload.grocerPrice === undefined ||
                    this.state.data.payload.grocerPrice === ""
                  }
                />

                <Button
                  text="CANCEL"
                  onPress={() => {
                    this.stateChangeHandler("showGrid", "stage", false);
                    //console.log("cancelling..." + this.props.listYPos);
                    window.scroll(0, parseInt(this.props.listYPos));
                  }}
                  colorScheme="warning"
                  disabled={false}
                />

                <Button
                  text="DIRECT DELIVER"
                  onPress={() => {
                    window.confirm(
                      "Please use this option carefully." +
                        " Did you arrange collection of cash and delivery of goods yourself?" +
                        " Press Ok to confirm. "
                    ) && this.directSave(false, true);
                  }}
                  colorScheme="warning"
                  disabled={false}
                />
              </CardActionsSupplemental>
            </CardActions>
          </div>
        </div>
        <div
          style={{
            color: "#333",
            fontSize: "medium",
            fontWeight: "bold",
            fontFamily: "RobotMedium",
            backgroundColor: "gainsboro",
            padding: "5px",
            marginTop: "10px"
          }}
        >
          <div
            style={{
              paddingTop: "10px",
              paddingBottom: "6px"
            }}
          >
            <div>REQUESTED ITEMS</div>
            <div>
              {this.getFormattedCellValue(
                this.state.fullPayload.requestedItems
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  getPackingDone = () => {
    return (
      <div>
        <div
          style={{
            fontSize: "medium",
            fontWeight: "bold",
            margin: "5px"
          }}
        >
          Is the order packed and is ready for lorry pickup? Tap on Packing
          Completed button to complete this order's packing.
        </div>
        <div
          style={{
            border: "1px solid grey",
            borderRadius: "5px",
            padding: "5px"
          }}
        >
          <div
            style={{
              marginTop: "3px",
              marginBottom: "3px"
            }}
          >
            <CardActions>
              <CardActionsSupplemental>
                <Button
                  text="PACKING COMPLETED"
                  onPress={() => {
                    window.confirm(
                      "Are the items in this order packed and readied for pickup? Have you also clearly written cell number on the packet? Tap OK to confirm."
                    ) && this.directSave(true);
                  }}
                  colorScheme="primary"
                  disabled={false}
                />

                <Button
                  text="CANCEL"
                  onPress={() => {
                    this.stateChangeHandler("showGrid", "stage", false);
                  }}
                  colorScheme="warning"
                  disabled={false}
                />
              </CardActionsSupplemental>
            </CardActions>
          </div>
        </div>
        <div
          style={{
            color: "#333",
            fontSize: "medium",
            fontWeight: "bold",
            fontFamily: "RobotMedium",
            backgroundColor: "gainsboro",
            padding: "5px",
            marginTop: "10px"
          }}
        >
          <div
            style={{
              paddingTop: "10px",
              paddingBottom: "6px"
            }}
          >
            <div>REQUESTED ITEMS</div>
            <div>
              {this.getFormattedCellValue(
                this.state.fullPayload.requestedItems
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  handleEdit = (key, path, fullPayload) => {
    //console.log("doing...: " + JSON.stringify(fullPayload));
    window.scroll(0, 0);
    this.stateChangeHandler(fullPayload, "fullPayload", false);
    if (
      fullPayload &&
      fullPayload.status &&
      fullPayload.status === "WITH GROCER FOR PRICE"
    ) {
      this.stateChangeHandler("getPrice", "stage", false);
    }
    if (
      fullPayload &&
      fullPayload.status &&
      fullPayload.status === "WITH GROCER FOR PACKING"
    ) {
      this.stateChangeHandler("getPackingDone", "stage", false);
    }
  };

  directSave = (packingDone, directDelivered) => {
    let cloudPath = "deliveryRequest";
    let tgtPayload = _.cloneDeep(this.state.fullPayload);

    if (!packingDone && !directDelivered) {
      if (
        !tgtPayload.supplierPrices &&
        tgtPayload.supplierPrices === undefined
      ) {
        tgtPayload.supplierPrices = [];
      }

      tgtPayload.supplierPrices.push({
        price: this.state.data.payload.grocerPrice
          ? this.state.data.payload.grocerPrice
          : "",
        notes: this.state.data.payload.notes
          ? this.state.data.payload.notes
          : "",
        supplierName: this.state.supplierName
      });
    }
    let key = tgtPayload.key;

    if (packingDone && packingDone === true) {
      tgtPayload["status"] = "WAITING FOR LORRY";
    }
    if (directDelivered && directDelivered === true) {
      tgtPayload["status"] = "DELIVERED";
    }

    if (key && key !== "") {
      cloudPath = cloudPath + "/" + key;

      this.props.firebase.db
        .ref("/" + cloudPath)
        .once("value")
        .then(snap => {
          this.stateChangeHandler("showGrid", "stage", false);
          return snap.ref.set(tgtPayload);
        })
        .catch(err => {
          console.log(err);
          this.stateChangeHandler("showGrid", "stage", false);
          return console.log("some error: " + err);
        });
    }
  };

  handleAddNew = () => {
    ////console.log("generating new");
    let initData = getInitData(
      this.state.tableName,
      this.props.createTable,
      this.props.userProfile
    );
    if (initData && initData !== undefined) {
      this.stateChangeHandler(false, "showGrid", false);
      this.props.onSetUiFlag("operationType", "add");
      this.props.onSetUiFlag("tableName", this.state.tableName);
      this.props.onAddNew({
        path: this.state.tableName,
        data: { ...initData }
      });
    }
  };

  handleEditCancel = () => {
    this.stateChangeHandler(true, "showGrid", false);
  };

  getDashView = () => {
    return <div></div>;
  };

  getFields = () => {
    ////console.log("test");
    alert("test");
  };

  getData = () => {
    let dTableName = this.state.tableName;

    if (this.state.tableName === "viewReports") {
      dTableName = "reports";
    }
    if (dTableName !== "dashboard") {
      if (
        this.state.tableDefs[dTableName] &&
        this.state.tableDefs[dTableName] !== undefined
      ) {
        //console.log(JSON.stringify(this.props.db[dTableName]));
        return searchRecords(
          this.props.db[dTableName],
          this.state.searchVal,
          this.state.tableDefs[dTableName].searches
            ? this.state.tableDefs[dTableName].searches
            : [],
          this.state.searchFilters,
          this.state.searchDateFilters
        );
      } else {
        return [];
      }
    }
  };

  doStateUpdateForSearch = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        searchVal: this.refs.searchText.value
      };
    });
  };

  doDelaySearch = () => {
    ////console.log("doning search...");
    const q = this.refs.searchText.value;
    //this.stateChangeHandler("searchVal", q, false);
    if (q.length < 5) {
      this.getDataThrottled();
    } else {
      this.getDataDebounced();
    }
  };

  getNewButton = () => {
    if (this.state.showGrid) {
      return (
        <Button
          colorScheme="primary"
          onPress={() => this.handleAddNew()}
          text="Add New"
        />
      );
    }
  };

  getFiltersList = () => {
    let filtersList = [];
    if (this.props.createTable && this.props.createTable.length > 0) {
      let tableObj = this.props.createTable.find(
        item => item.name === this.state.tableName
      );

      if (tableObj && tableObj !== undefined) {
        if (tableObj.filters && tableObj.filters !== undefined) {
          filtersList = tableObj.filters;
        }
      }

      return filtersList;
    } else {
      return [];
    }
  };

  getFilterDropDowns = () => {
    if (this.state.showGrid) {
      return (
        <div>
          <GridFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
          <GridDateFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchDateFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
        </div>
      );
    }
  };

  getGrid = () => {
    return (
      <ContentGridVanilla
        data={this.getData()}
        tableName={this.state.tableName}
        tableDef={this.state.tableDefs[this.state.tableName]}
        handleEdit={this.handleEdit}
        handleDelete={this.handleDelete}
        role={"grocer"}
      />
    );
  };

  getEnrichedString = (ogString, searchObj) => {
    //console.log(ogString + JSON.stringify(searchObj));
    let strArray = ogString.split(" ").map(word => {
      //console.log(word + " = " + searchObj[word]);
      if (searchObj[word] && searchObj[word] !== undefined) {
        return searchObj[word];
      } else {
        return word;
      }
    });

    return strArray.join(" ");
  };

  genNotification = (recPayload, opType) => {
    let usersList = [];
    let updateText = undefined;
    let createText = undefined;
    let deleteText = undefined;
    let tableObj = this.props.createTable.find(
      item => item.name === this.state.tableName
    );

    if (tableObj && tableObj !== undefined) {
      usersList = tableObj.notifyUsers;
      createText = tableObj.createNotifyText;
      updateText = tableObj.updateNotifyText;
      deleteText = tableObj.deleteNotifyText;

      if (
        opType === "update" &&
        updateText &&
        updateText !== "" &&
        updateText !== null
      ) {
        //console.log(" updateText: " + updateText + " opType: " + opType);
        this.props.onNotifyUsers(
          this.getEnrichedString(updateText, recPayload),
          usersList
        );
      } else if (
        opType === "delete" &&
        deleteText &&
        deleteText !== "" &&
        deleteText !== null
      ) {
        //console.log(" deleteText: " + deleteText + " opType: " + opType);
        this.props.onNotifyUsers(
          this.getEnrichedString(deleteText, recPayload),
          usersList
        );
      } else if (
        opType === "create" &&
        createText &&
        createText !== "" &&
        createText !== null
      ) {
        //console.log("createText: " + createText + " opType: " + opType);
        this.props.onNotifyUsers(
          this.getEnrichedString(createText, recPayload),
          usersList
        );
      }
    }
  };

  getSelectedPoCount = () => {
    let poRecs = this.getData();
    if (poRecs && poRecs.length && poRecs.length > 0) {
      return poRecs.length;
    } else {
      return 0;
    }
  };

  getInputField = (fieldName, poDefs) => {
    return getInputField(
      fieldName,
      "projectPos",
      this.state.data,
      this.stateChangeHandler,
      false,
      poDefs,
      this.props.db,
      isMobile
    );
  };

  getTopHeader = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 99999,
          top: "60px",
          width: "95%"
        }}
      >
        <div className="wrapzz">
          <div className="searchzz">
            <input
              type="text"
              className="searchTermzz"
              placeholder="Search..."
              ref="searchText"
              onKeyUp={() => {
                window.scroll(0, 0);
                this.doDelaySearch();
              }}
            />
            <button
              type="submit"
              className="searchButtonzz"
              onClick={() => {
                this.setState(prevState => {
                  return {
                    ...prevState,
                    searchVal: this.refs.searchText.value
                  };
                });
                ////console.log("searchText " + this.refs.searchText.value);
                ////console.log(JSON.stringify(this.state.searchVal));
              }}
            >
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    );
  };

  getMainContent = () => {
    return (
      <MainRegion>
        <Content>
          <Container>
            {this.getTopHeader()}
            <div
              style={{
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
                scrollBehavior: "smooth",
                marginTop: "60px"
              }}
            >
              {this.state.stage === "showGrid" && this.getGrid()}
              {this.state.stage === "getPrice" && this.getPriceConfirmation()}

              {this.state.stage === "getPackingDone" && this.getPackingDone()}
            </div>
          </Container>
          <div
            style={{
              minHeight: "500px"
            }}
          ></div>
        </Content>
      </MainRegion>
    );
  };

  render() {
    return (
      <div id="mainContainer" style={{ minHeight: "30000px" }}>
        <div>{this.getTopMenu()}</div>

        <div
          style={{
            marginTop: "40px"
          }}
        >
          <div>{this.getMainContent()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.db.userProfile,
    userMenus: state.ui.userMenus,
    users: state.db.users,
    projects: state.db.projects,
    attendance: state.db.attendance,
    contacts: state.db.contacts,
    logistics: state.db.logistics,
    notices: state.db.notices,
    projectInvoices: state.db.projectInvoices,
    deletedprojectInvoices: state.db.deletedprojectInvoices,
    projectClaims: state.db.projectClaims,
    projectDos: state.db.projectDos,
    projectPos: state.db.projectPos,
    projectQuotes: state.db.projectQuotes,
    reports: state.db.reports,
    suppliers: state.db.suppliers,
    tasks: state.db.tasks,
    currentUser: state.db.userProfile,
    isAdmin: state.ui.isThisAdmin,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    userUid: state.ui.userUid,
    currUserRole: state.ui.currUserRole,
    createFields: state.db.createFields,
    createTable: state.db.createTable,
    testTable: state.db.testTable,
    listOfTables: state.db.listOfTables,
    menuDesigner: state.db.menuDesigner,
    uploadButton:
      state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined
        ? state.ui.dataUploadButton
        : false,
    db: state.db,
    listYPos: state.ui.listYPos
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onSelectRecord: params => {
      dispatch(selectARecord(params));
      dispatch(setUiFlag("tableName", params.path));
    },
    onAddNew: data => dispatch(initSelectedRecord(data)),
    loadStats: parsedRes => dispatch(loadAllStats(parsedRes)),
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onSignOut: () => {
      dispatch(resetRedux());
      dispatch(setUiFlag("userMenus", []));
    },
    loadFbData: (tableName, firebase) =>
      dispatch(loadFbData(tableName, firebase)),
    onNotifyUsers: (msgBody, arrayOfUsers) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers)),
    onGetId: data => dispatch(getId(data)),
    onGetAcctStatement: data => dispatch(getAcctStatement(data)),
    onGetAcctBalance: data => dispatch(getAcctBalance(data)),
    onAddArray: data => dispatch(actionAddArray2Redux(data))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(Grocer);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/Grocer.jsx